<template>
  <b-container class="bv-example-row bv-example-row-flex-cols h-100">
    <b-row align-v="center h-100">
      <b-col align-self="center">
        <h2>Bienvenido</h2>
        <b-form @submit="onSubmit">
          <b-form-group
            id="input-group-1"
            label="Nombre de Usuario"
            label-for="input-1"
          >

            <b-form-input
              id="input-1"
              v-model="email"
              type="text"
              required
              placeholder="Nombre de Usuario"
            ></b-form-input>
          </b-form-group>


          <b-form-group
            id="input-group-1"
            label="Contraseña"
            label-for="password"
          >
            <b-form-input
              id="password"
              v-model="password"
              type="password"
              required
              placeholder="Contraseña"
            ></b-form-input>
          </b-form-group>

          <b-alert show variant="danger" v-show="error">{{errorMsg}}</b-alert>

          <b-button type="submit" variant="primary">Entrar</b-button>
          <!--<b-button type="submit" variant="danger" v-on:click="lanzador">Lanzador</b-button>-->
        </b-form>
      </b-col>
      <b-col>
        <img alt="Vue logo" src="../assets/logo.png" style="width: 250px;">
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import Parse from 'parse'
  import Vue from 'vue'

  Vue.use(Parse)
  Parse.initialize("bBzZ7wYYGIpQkPPB");
  Parse.serverURL = 'https://aircab.herokuapp.com/parse'
  // Parse.initialize("BewIZ9dlh4gNBStm")
  // Parse.serverURL = 'https://aircabdev.herokuapp.com/parse'
  export default {
    data() {
      return {
        email: null,
        password: null,
        error: false,
        errorMsg: ''
      }
    },
    async created () {
      var currentUser = Parse.User.current()
      console.log('created currentUser', currentUser)
    },
    methods: {
      lanzador () {
        window.open('/','winname',"directories=0,titlebar=0,toolbar=0,location=0,status=0,menubar=0,scrollbars=no,resizable=no,width=400,height=350");
      },
      async onSubmit (evt) {
        evt.preventDefault()
        let vue = this
        vue.error = false
        if(vue.email.length > 0 && vue.password.length > 0){
          vue.error = false
          try {
            let user = await Parse.User.logIn(vue.email, vue.password)
            console.log('usuario', user)
            vue.$router.replace('/')
            /*
            if (user.get('virtual')) {
              vue.$router.replace('home')
            } else {
              Parse.User.logOut().then(() => {
                vue.error = true
                vue.errorMsg = 'Usuario sin privilegios'
              })
            }
            */
          } catch (error) {
            vue.error = true
            vue.errorMsg = 'Usuario / Contraseña Incorrecta'
            console.log('error', error)
          }

        }
                
      }
    }
  }
</script>